import { TOKEN_IDomKeyboard, type IDomKeyboard } from "@/services/DomKeyboard";
import { TOKEN_IMouseState, type IMouseState } from "@/services/MouseState";
import { TOKEN_INavigationRedirect, type INavigationRedirect } from "@/services/NavigationRedirect";
import { ProjectBusEvents, TOKEN_IProjectBus, type IProjectBus } from "@/services/ProjectBus";
import { makeAutoObservable } from "mobx";
import { inject, injectable } from "tsyringe";
import RunningActionStore, { TOKEN_RunningActionStore } from "./utility-stores/RunningActionStore";
import { type IWrapTranslations, TOKEN_IWrapTranslations } from "@/services/WrapTranslations";
import { TOKEN_IWrapAuth0, type IWrapAuth0 } from "@/services/WrapAuth0";

export const TOKEN_AppStore = Symbol("AppStore");

@injectable()
export class AppStore {
    private _firstRender = true;

    renderView = async () => {
        if (!this._firstRender) return;
        this._firstRender = false;

        this.mouseState.initialize();
        this.domKeyboard.initialize();

        await this.runningActionStore.manageAction(async () => {
            await this.wrapAuth0.initialize();
            await this.navigationRedirect.checkAndRedirect(false);
        }, true, this.t.t("loading_project"));
    }

    private onUserHitBackButton = async (data: ProjectBusEvents['NAVIGATION_CHANGED']): Promise<void> => {
        if (!data.isBackButton) return;

        await this.runningActionStore.manageAction(async () => {
            await this.navigationRedirect.checkAndRedirect(false);
        }, true, this.t.t("loading_project"));
    }

    constructor(
        @inject(TOKEN_INavigationRedirect) private navigationRedirect: INavigationRedirect,
        @inject(TOKEN_IWrapAuth0) private wrapAuth0: IWrapAuth0,
        @inject(TOKEN_IMouseState) private mouseState: IMouseState,
        @inject(TOKEN_IDomKeyboard) private domKeyboard: IDomKeyboard,
        @inject(TOKEN_IProjectBus) projectBus: IProjectBus,
        @inject(TOKEN_IWrapTranslations) private readonly t: IWrapTranslations,
        @inject(TOKEN_RunningActionStore) private readonly runningActionStore: RunningActionStore,
    ) {
        makeAutoObservable(this);

        projectBus.subscribe_userHitBackButton(this.onUserHitBackButton);
    }
}